<template>
  <transition name="router-home" enter-active-class="animated fadeIn">
    <div v-show="exibir">
      <div v-if="userDadosPerfilAtual.identificadorperfil === 1 ||
      userDadosPerfilAtual.identificadorperfil === 3">
        <HomeAdministrador />
      </div>

      <v-layout column fill-height v-if="userDadosPerfilAtual.identificadorperfil === 2 ||
        userDadosPerfilAtual.identificadorperfil === 8 ||
        userDadosPerfilAtual.identificadorperfil === 6 ||
        userDadosPerfilAtual.identificadorperfil === 20">
        <HomeProfessor :dados="dadosHome"/>
      </v-layout>
    </div>
  </transition>
</template>

<script>
import store from '@/store/index';
import HomeProfessor from '@/components/HomeProfessor';
import HomeAdministrador from '@/components/HomeAdministrador';
import { mapGetters } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const HomeRepository = RepositoryFactory.get('home');

const buscarDadosHome = async () => {
  let data = {};

  switch(store.getters.userDadosPerfilAtual.identificadorperfil) {
    case 2: case 6: case 8: //Professor, Diretor, Coordenador
      const response = await HomeRepository.getProfessorHome({
        ...store.getters.school,
        ano: store.getters.getAnoSistema,
      });
      data = {
        ...response.data.results,
      };
    break;
  }

  return data;
};

export default {
  name: 'home',
  components: {
    HomeAdministrador,
    HomeProfessor,
  },
  data() {
    return {
      dadosHome: {},
      exibir: true,
    };
  },
  watch: {
    getAnoSistema(newVal, oldVal) {
      this.reloadHome();
    },
    school(newVal, oldVal) {
      this.reloadHome();
    },
  },
  async beforeRouteEnter(to, from, next) {
    let data = [];
    try {
      data = await buscarDadosHome();
    } catch (error) {
      next('logoff');
    }
    next(vm => vm.load(data));
  },
  methods: {
    load(data) {
      this.dadosHome = data;
      this.$Progress.finish();
    },
    async reloadHome() {
      try {
        this.$Progress.start();
        this.exibir = false;
        this.dadosHome = await buscarDadosHome();
      } finally {
        this.$Progress.finish();
        this.exibir = true;
      }
    }
  },
  computed: {
    ...mapGetters(['userDadosPerfilAtual', 'getAnoSistema', 'school']),
  },
};
</script>

<style lang="scss">
.graficos {
  display: flex;

  .graficos-itens {
    width: 48%;
    margin: 10px;
  }
}

.home-principal{
    margin-top: 10px;
    padding: 38px 15px;
    text-align: center;
    border-radius: 5px;
    margin-bottom: 15px;
    font-weight: bold;

    .titulo{
      font-size: 20px;
      span {
        font-size: 18px;
      }
    }
}

@media only screen and (max-width: 550px){
  .graficos {
    flex-wrap: wrap;
    .graficos-itens {
      flex: 1;
    }
  }
}
</style>
